import React from "react";
import Select from "react-select";
import T from "../TheTool";

function GUI_Select(props) {
	var label1 = T.getValue(props.label, "");
	var label1size = T.getValue(props.labelsize, 24); //20);
	var label2size = T.getValue(props.labelsize2, 20); //20);
	var width1 = T.getValue(props.width1, 150);
	var labelBold = T.getValue(props.labelBold, true);
	var paddingR = T.getValue(props.paddingR, 20);
	var marginT = T.getValue(props.marginT, 20);


	// function SelectionChange(event) {
	// 	// props.text1Change(event.target.value);
	// 	console.log("xxx" + event.value);
	// }

	return (
		<div
			// class="flexbox-container"
			className="flexbox-container"
			style={{
				alignItems: "center",
				// justifyContent: "center",
				marginTop: marginT,
			}}
		>
			<div style={{ width: width1 }}>
				<label style={{ fontSize: label1size, paddingRight: paddingR }}>
					{labelBold ? <b>{label1}</b> : { label1 }}
				</label>
			</div>
			<div style={{ width: "100%" }}>
				<label style={{ fontSize: label2size , textAlign: 'center'}}>
				<Select
					id="selectMode"
					name="selectMode"
					// width="500"
					style={{  }}
					options={props.selecter_option}
					value={props.selectedOption}
					// onChange={handleChange}
					// defaultValue={{ value: "1", label: "" }}
					defaultValue={props.selectedOption}
					onChange={(e) => props.setSelectedOption(e)}
					// onChange={(e) => SelectionChange(e)}
				/>
				</label>
			</div>
		</div>
	);
}

export default GUI_Select;
